module.exports = __webpack_public_path__ + "img/LREXFooterLogo.d3a41d7b.jpg";